import { extend } from "vee-validate";
import { required, email, confirmed, integer, image, min_value } from "vee-validate/dist/rules";

var message = "Invalid input, please check you have entered the information correctly.";

// Define the front end rules
extend("required", {
    ...required,
    message: "Field required",
});

extend("email", {
    ...email,
    message,
});

extend("confirmed", {
    ...confirmed,
    message: "Passwords do not match",
});

extend("min", {
    validate(value, { minLength }) {
        return value.length >= minLength;
    },
    params: ["minLength"],
    message,
});

extend("max", {
    validate(value, { maxLength }) {
        return value.length <= maxLength;
    },
    params: ["maxLength"],
    message,
});

extend("integer", {
    ...integer,
    message,
});

extend("image", {
    ...image,
    message,
});

extend("positive", (value) => {
    let number = parseInt(value.replace(/\,/g, ''), 10);
    if (number >= 0) {
        return true;
    }

    return "This field must be a positive number";
});

extend("min_value", {
    validate(value = 0, { minValue }) {
        let minValueNumber = parseInt(minValue.replace(/\,/g, ''), 10);
        let valueNumber = parseInt(value.replace(/\,/g, ''), 10);
        if (valueNumber >= minValueNumber) {
            return true;
        }
    },
    params: ["minValue"],
    message: "The value must be a minimum of {minValue}"
});

// Semi-redundant, but is in place as it keeps the usage of the "rules" props on custom components consistent
extend("optional", {
    validate: (value) => true,
});
